@switch (mode()) {
  @case ('thumbnail') {
    @switch (videoAsset().status) {
      @case ('ready') {
        <i class="fa fa-play-circle"></i>
      }
      @case ('pending') {
        <i class="fa fa-spinner fa-spin"></i>
      }
      @case ('failed') {
        <i class="fa fa-exclamation-circle text-danger"></i>
      }
    }
  }
  @default {
    @switch (videoAsset().status) {
      @case ('pending') {
        <div class="asset-video-pending"
             [style.aspect-ratio]="videoAsset().width + ' / ' + videoAsset().height">
          @if (thumbnailUrl()) {
            <img class="asset-video-bg" [src]="thumbnailUrl()!" alt="" />
          } @else {
            <div class="asset-video-placeholder-bg">
              <i class="fa fa-film"></i>
            </div>
          }
          <div class="asset-video-overlay">
            <div class="asset-video-status">
              <i class="fa fa-spinner fa-spin"></i>
              <span>{{ 'aiReport.video_creating' | translate }}</span>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm asset-video-check-btn"
                    (click)="checkStatus()" [disabled]="checking()">
              <i class="fa" [ngClass]="checking() ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
              {{ (checking() ? 'aiReport.video_checking' : 'aiReport.video_check_status') | translate }}
            </button>
            @if (checkError()) {
              <span class="asset-video-check-error">{{ checkError() }}</span>
            }
          </div>
        </div>
      }
      @case ('ready') {
        <video
          [style.aspect-ratio]="videoAsset().width + ' / ' + videoAsset().height"
          [attr.aria-label]="videoAsset().altText"
          controls
          preload="metadata">
          <source [src]="videoSrc()" type="video/mp4" />
        </video>
      }
      @case ('failed') {
        <div class="asset-video-failed">
          <span>{{ videoAsset().errorMessage }}</span>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onTryAgain()">
            <i class="fa fa-repeat"></i> {{ 'aiReport.video_try_again' | translate }}
          </button>
        </div>
      }
    }
  }
}
